import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/base/Button';

export default function AuthPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    phone: '',
    email: '',
    fullName: '',
    city: ''
  });
  
  const isRTL = i18n.language === 'ar';
  
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Simulate authentication
    navigate('/home');
  };
  
  const handleGuestMode = () => {
    navigate('/home');
  };
  
  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'ar' ? 'en' : 'ar');
  };
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#FDFDFD] to-[#F8F9FA] flex flex-col">
      {/* Header */}
      <div className="flex justify-between items-center p-4 pt-12">
        <div className="flex items-center">
          <div className="w-10 h-10 bg-[#0056A6] rounded-xl flex items-center justify-center mr-3">
            <i className="ri-car-line text-white text-xl"></i>
          </div>
          <h1 className="text-2xl font-bold text-[#0056A6]" style={{ fontFamily: 'Pacifico, serif' }}>
            MovePro
          </h1>
        </div>
        
        <button
          onClick={toggleLanguage}
          className="px-3 py-1 bg-[#707070] text-white rounded-full text-sm font-medium"
        >
          {i18n.language === 'ar' ? 'EN' : 'عربي'}
        </button>
      </div>
      
      {/* Main Content */}
      <div className="flex-1 px-6 py-8">
        {/* Welcome Text */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-[#333333] mb-2">
            {isLogin ? 'مرحباً بك مرة أخرى' : 'انضم إلى MovePro'}
          </h2>
          <p className="text-[#7A7A7A] text-base">
            {isLogin ? 'سجل دخولك للمتابعة' : 'أنشئ حساباً جديداً للبدء'}
          </p>
        </div>
        
        {/* Auth Toggle */}
        <div className="flex bg-[#F5F5F5] rounded-xl p-1 mb-8">
          <button
            onClick={() => setIsLogin(true)}
            className={`flex-1 py-3 rounded-lg font-medium transition-all duration-200 ${
              isLogin 
                ? 'bg-white text-[#0056A6] shadow-sm' 
                : 'text-[#707070]'
            }`}
          >
            {t('login')}
          </button>
          <button
            onClick={() => setIsLogin(false)}
            className={`flex-1 py-3 rounded-lg font-medium transition-all duration-200 ${
              !isLogin 
                ? 'bg-white text-[#0056A6] shadow-sm' 
                : 'text-[#707070]'
            }`}
          >
            {t('register')}
          </button>
        </div>
        
        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {!isLogin && (
            <div>
              <label className="block text-[#333333] font-medium mb-2">
                {t('fullName')}
              </label>
              <input
                type="text"
                value={formData.fullName}
                onChange={(e) => setFormData({...formData, fullName: e.target.value})}
                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-base focus:outline-none focus:border-[#0056A6] transition-colors duration-200"
                placeholder="أدخل اسمك الكامل"
                required={!isLogin}
              />
            </div>
          )}
          
          <div>
            <label className="block text-[#333333] font-medium mb-2">
              {t('phone')}
            </label>
            <div className="relative">
              <input
                type="tel"
                value={formData.phone}
                onChange={(e) => setFormData({...formData, phone: e.target.value})}
                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-base focus:outline-none focus:border-[#0056A6] transition-colors duration-200"
                placeholder="+966 5X XXX XXXX"
                required
              />
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                <i className="ri-phone-line text-[#707070] text-lg"></i>
              </div>
            </div>
          </div>
          
          <div>
            <label className="block text-[#333333] font-medium mb-2">
              {t('email')} {!isLogin && '(اختياري)'}
            </label>
            <div className="relative">
              <input
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-base focus:outline-none focus:border-[#0056A6] transition-colors duration-200"
                placeholder="example@email.com"
                required={isLogin}
              />
              <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                <i className="ri-mail-line text-[#707070] text-lg"></i>
              </div>
            </div>
          </div>
          
          {!isLogin && (
            <div>
              <label className="block text-[#333333] font-medium mb-2">
                {t('city')}
              </label>
              <div className="relative">
                <input
                  type="text"
                  value={formData.city}
                  onChange={(e) => setFormData({...formData, city: e.target.value})}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-xl text-base focus:outline-none focus:border-[#0056A6] transition-colors duration-200"
                  placeholder="الرياض، جدة، الدمام..."
                  required
                />
                <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                  <i className="ri-map-pin-line text-[#707070] text-lg"></i>
                </div>
              </div>
            </div>
          )}
          
          <Button type="submit" className="w-full" size="lg">
            {t('continue')}
          </Button>
        </form>
        
        {/* Guest Mode */}
        <div className="mt-6 text-center">
          <button
            onClick={handleGuestMode}
            className="text-[#707070] font-medium hover:text-[#0056A6] transition-colors duration-200"
          >
            {t('guestMode')}
          </button>
        </div>
      </div>
    </div>
  );
}